import PropTypes from 'prop-types';
import ChevronDownIcon from '@untitled-ui/icons-react/build/esm/ChevronDown';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

import { usePopover } from 'src/hooks/use-popover';

import { TenantPopover } from './tenant-popover';

const tenants = ['מידע כללי', 'זימון כללי', 'זימון התמחויות','תשלום','חברים חדשים','זימון ערבית'];

export const TenantSwitch = (props) => {
  const popover = usePopover();
  
  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        spacing={2}
        {...props}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            color="inherit"
            variant="h6"
          >
            מכבי
          </Typography>
        </Box>
        
      </Stack>
      
    </>
  );
};

TenantSwitch.propTypes = {
  sx: PropTypes.object
};
